import { computed } from '@ember/object';
import BlockRange from '../block-range';
import BlockMutationResult from '../block-mutation-result';
import TextBlock from './base/text-block';
import AttributeReplacer from '@intercom/embercom-composer/lib/attribute-replacer';
import AlignableBlock from './mixins/alignable-block';
import AttributeReplacement from '@intercom/embercom-composer/blocks/replacements/attribute';
import LinkReplacement from '@intercom/embercom-composer/blocks/replacements/link';
import EmojiReplacement from '@intercom/embercom-composer/blocks/replacements/emoji';
import InlineCodeReplacement from '@intercom/embercom-composer/blocks/replacements/inline-code';
import MarkdownLinkReplacement from '@intercom/embercom-composer/blocks/replacements/markdown-link';
import UnorderedListReplacement from '@intercom/embercom-composer/blocks/replacements/unordered-list';
import OrderedListReplacement from '@intercom/embercom-composer/blocks/replacements/ordered-list';
import HeadingReplacement from '@intercom/embercom-composer/blocks/replacements/heading';
import SubheadingReplacement from '@intercom/embercom-composer/blocks/replacements/subheading';
import ImageReplacement from '@intercom/embercom-composer/blocks/replacements/image';
import CodeReplacement from '@intercom/embercom-composer/blocks/replacements/code';
import Em from 'ember';
export default TextBlock.extend(AlignableBlock, {
  type: 'paragraph',
  splitType: 'paragraph',
  tagName: 'p',
  isParagraph: true,
  openingTag: computed('tagName', 'id', 'generatedAt', 'align', function () {
    return `<${this.tagName} data-id="${this.id}" data-generated-at="${this.generatedAt}" data-align="${this.align}">`;
  }),
  text: '',
  blockReplacements: [UnorderedListReplacement, OrderedListReplacement, HeadingReplacement, SubheadingReplacement, ImageReplacement, CodeReplacement],
  inlineReplacements: [LinkReplacement, EmojiReplacement, InlineCodeReplacement, MarkdownLinkReplacement, AttributeReplacement],
  init() {
    this.set('attributeReplacer', new AttributeReplacer(this));
    let replacementsToSkip = this.get('replacementsToSkip') || [];
    this.set('replacementsToSkip', replacementsToSkip);
    this._super();
  },
  serialized: Em.computed('serializedInnerHtml', 'align', function () {
    let serialized = this._super();
    if (this.get('config.allowAlignment')) {
      serialized.align = this.get('align');
    }
    return serialized;
  }),
  addReplacementToSkip(text) {
    this.get('replacementsToSkip').push(text);
  },
  split(blockRange) {
    let newBlock = this._super(blockRange);
    newBlock.set('align', this.get('align'));
    this.doInlineReplacements();
    return newBlock;
  },
  join(block) {
    if (block.get('isTextType')) {
      return this._joinWithTextType(block);
    }
    if (block.get('isListType') && block.get('isEmpty')) {
      return this._joinWithEmptyList(block);
    }
    if (block.get('isListType')) {
      return this._joinWithList(block);
    }
    return this._super(block);
  },
  deleteEntityById(id) {
    let entity = this.findEntityById(id);
    if (entity) {
      this.get('entities').removeObject(entity);
      if (entity.get('type') === 'anchor') {
        let pattern = this.get('text').slice(entity.get('startIndex'), entity.get('endIndex'));
        this.addReplacementToSkip(pattern);
      }
    }
  },
  _joinWithTextType(block) {
    let blocksToRemove = [];
    let text = this.get('text');
    this.set('entities', this._joinEntitiesFromRight(block));
    this.set('text', text + block.get('text'));
    blocksToRemove.pushObject(block);
    return BlockMutationResult.create({
      blocksToRemove,
      blockRange: BlockRange.atPositionIndex(text.length)
    });
  },
  _joinWithEmptyList(block) {
    return BlockMutationResult.create({
      blocksToRemove: [block],
      blockRange: BlockRange.atPositionIndex(this.get('text.length'))
    });
  }
});